export default __webpack_public_path__ + "static/media/home-feat-dyson.64795aa0.jpg";